export default "__VITE_ASSET__BcVSe435__"